import i18n from 'src/lib/i18n/i18n';
import View from '@play-co/timestep-core/lib/ui/View';
import ImageView from '@play-co/timestep-core/lib/ui/ImageView';
import PopupBasicLazy from '../../components/popups/PopupBasicLazy';
import AssetGroup from '@play-co/timestep-core/lib/ui/resource/AssetGroup';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import { NativePromoOrigin } from 'src/replicant/native';
import { GCInstant } from '../../../lib/gcinstant';
import { now } from 'src/StateObserver';
import { startNativeCrossplay } from 'src/game/crossplay/crossplay.sequence';
import { track } from 'src/lib/analytics/utils';

export default class PopupLoginCrossplay extends PopupBasicLazy {
  private static assetsGroup = new AssetGroup([
    'assets/native/generic_icon.png',
  ]);

  protected getAssetsGroup(): AssetGroup {
    return PopupLoginCrossplay.assetsGroup;
  }

  private originFeature: NativePromoOrigin = 'home_icon';

  constructor(opts: { superview: View; close: () => void }) {
    super({
      ...opts,
      skipMessage: true,
      height: 550,
      tracking: { feature: 'crossplay', $subFeature: 'popup-login-crossplay' },
    });

    // game icon
    this.box.addSubview(
      new ImageView({
        x: this.box.style.width * 0.5,
        y: 265,
        width: 429,
        height: 403,
        centerOnOrigin: true,
        centerAnchor: true,
        image: 'assets/native/generic_icon.png',
      }),
    );

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        x: this.box.style.width * 0.5,
        y: 475,
        width: 265,
        height: 90,
        fontSize: 31,
        font: 'Body',
        centerOnOrigin: true,
        centerAnchor: true,
        localeText: () => i18n('native.crossplay.login.cta'),
        onClick: () => this.handleCrossplayClick(),
        tracking: {
          feature: 'crossplay',
          $subFeature: 'popup-login-crossplay-login',
        },
      }),
    );
  }

  public async init(opts: { originFeature: NativePromoOrigin }) {
    super.init({
      title: i18n('native.crossplay.login.title'),
    });

    track('CrossplayPopupOpen', { feature: opts.originFeature });
    this.originFeature = opts.originFeature;
  }

  private async handleCrossplayClick() {
    await startNativeCrossplay({
      payload: GCInstant.entryData,
      onBeforeSwitch: (deepLink) =>
        track('LiffLoginCrossplaySwitch', {
          deepLinkLength: deepLink.length,
        }),
      tracking: {
        origin: this.originFeature,
        feature: 'crossplay_popup',
        subFeature: 'crossplay_popup_cta',
        timestamp: now(),
      },
      shouldPreserveChannel: this.originFeature === 'launch',
    });

    // Continue launch sequence in case player comes back to LINE
    this.opts.close();
  }
}
